import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../../services/api';
import Constants from '../../../services/constants';
import { showToast } from '../toastSlice';
import { hideLoader, showLoader } from '../loaderSlice';
import { logoutAction } from '../authSlice';

export const deleteOrganization = createAsyncThunk(
    'settings/deleteOrganization',
    async ({ orgId, password }, { dispatch }) => {
        try {
            dispatch(showLoader());
            const res = await api(
                'delete',
                Constants.END_POINT.settings + `organization/${orgId}`,
                { password }
            );
            if (res?.success) {
                dispatch(showToast({ 
                    severity: 'success', 
                    summary: 'Organization deleted successfully' 
                }));
                // Log out the user after successful deletion
                dispatch(logoutAction());
                return res.data;
            } else {
                dispatch(showToast({ 
                    severity: 'error', 
                    summary: res.message || 'Failed to delete organization' 
                }));
                return Promise.reject(res.message);
            }
        } catch (error) {
            dispatch(showToast({ 
                severity: 'error', 
                summary: 'Failed to delete organization. Please try again.' 
            }));
            return Promise.reject(error);
        } finally {
            dispatch(hideLoader());
        }
    }
);

const deleteOrgSlice = createSlice({
    name: 'deleteOrg',
    initialState: {
        loading: false,
        error: null
    },
    reducers: {
        resetError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteOrganization.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteOrganization.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(deleteOrganization.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const { resetError } = deleteOrgSlice.actions;

export default deleteOrgSlice.reducer;
